import { PositionSubscriptionType } from 'src/constants';
import { ConfirmationEmailSent } from './ConfirmationEmailSent';
import { SuccessfulSubscription } from './SuccessfulSubscription';

export const SubscriptionCreated: React.FC<{
  email: string;
  subscriptionType: PositionSubscriptionType;
}> = ({ email, subscriptionType }) => {
  if (subscriptionType === PositionSubscriptionType.Candidate) {
    return <ConfirmationEmailSent email={email} />;
  }
  if (subscriptionType === PositionSubscriptionType.Referral) {
    return <SuccessfulSubscription />;
  }

  return null;
};
